import { pick } from 'Helpers/Affordances';
import fr from 'facet-rest';
import React from 'react';
import PropTypes from 'prop-types';
import SecuritySection
  from 'Components/Flyouts/HouseholdInfo/Sections/Security/Layout';

const HouseholdSectionSecurityPicker = ({ resource }) => {
  return pick(resource, {
    [fr.relationships.householdSectionSecurity.name]: (<SecuritySection relationshipLink={resource?.relationship(fr.relationships.householdSectionSecurity.name)?.link('related')} />),
  }, null);
};

HouseholdSectionSecurityPicker.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
HouseholdSectionSecurityPicker.defaultProps = {};

export default HouseholdSectionSecurityPicker;
